import { render, staticRenderFns } from "./WhatsIncluded.vue?vue&type=template&id=0d9e3d09&scoped=true&"
import script from "./WhatsIncluded.vue?vue&type=script&lang=js&"
export * from "./WhatsIncluded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e3d09",
  null
  
)

export default component.exports